import { CHAT_MESSAGES, ChatMessage } from "../../db/chat";
import { DatabaseTimestampServerValue, RealtimeReference } from "../../db/common";
import { BaseTwoLayerDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Message Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatMessageService extends BaseTwoLayerDatabaseService<ChatMessage> {
    protected getBasePath(): string {
        return CHAT_MESSAGES;
    }

    //make it public for sub on change for FE
    public getParentRef(channelId: string): RealtimeReference {
        return super.getParentRef(channelId);
    }

    //@overwrite
    create(channelId: string, data: Omit<ChatMessage, 'timestamp' | 'read'>): Promise<string> {
        return super.create(channelId,
            {
                timestamp: DatabaseTimestampServerValue,
                read: {},
                ...data,
            }
        )
    }
}
